module.exports = __webpack_public_path__ + "img/stripe-navy-blue.607d7081.svg";